(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["elohm-access-gate"] && !Shopify.designMode) return;
  try {
    
  (() => {
    function revealKlaviyoRoots() {
      document.querySelectorAll('form.klaviyo-form').forEach((form) => {
        let root = form;

        while (root.parentElement && root.parentElement !== document.body) {
          root = root.parentElement;
        }

        if (root.parentElement === document.body && root.id !== 'MainContent') {
          root.classList.add('elohm-klaviyo-root');
        }
      });
    }

    function initializeKlaviyo() {
      revealKlaviyoRoots();

      if (window.elohmKlaviyoObserver || !document.body) return;

      window.elohmKlaviyoObserver = new MutationObserver(revealKlaviyoRoots);
      window.elohmKlaviyoObserver.observe(document.body, { childList: true, subtree: true });
    }

    function initializeGate(gate) {
      if (!gate || gate.dataset.elohmInitialized === 'true') return;
      gate.dataset.elohmInitialized = 'true';

      const dialog = gate.querySelector('[data-elohm-access-dialog]');
      const openButton = gate.querySelector('[data-elohm-open-access]');
      const closeButton = gate.querySelector('[data-elohm-close-access]');
      const accessInput = gate.querySelector('input[name="password"]');

      document.documentElement.classList.add('elohm-access-is-locked');
      initializeKlaviyo();

      if (dialog && gate.querySelector('[data-elohm-password-error]')) {
        if (typeof dialog.showModal === 'function') dialog.showModal();
        else dialog.setAttribute('open', '');
      }

      if (openButton && dialog) {
        openButton.addEventListener('click', () => {
          if (typeof dialog.showModal === 'function') dialog.showModal();
          else dialog.setAttribute('open', '');
          requestAnimationFrame(() => accessInput?.focus());
        });
      }

      if (closeButton && dialog) {
        closeButton.addEventListener('click', () => {
          if (typeof dialog.close === 'function') dialog.close();
          else dialog.removeAttribute('open');
          openButton?.focus();
        });
      }
    }

    function initializeAll(root = document) {
      root.querySelectorAll('[data-elohm-access-gate]').forEach(initializeGate);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initializeAll(), { once: true });
    } else {
      initializeAll();
    }

    document.addEventListener('shopify:section:load', (event) => initializeAll(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["let-em-copy-teaser"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (customElements.get('let-em-copy-teaser')) return;

    class LetEmCopyTeaser extends HTMLElement {
      connectedCallback() {
        if (this.dataset.initialized === 'true') return;
        this.dataset.initialized = 'true';
        this.groups = Array.from(this.querySelectorAll('[data-let-em-copy-digits]'));
        this.motionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.handleMotionChange = () => this.restart();

        if (typeof this.motionQuery.addEventListener === 'function') {
          this.motionQuery.addEventListener('change', this.handleMotionChange);
        }

        this.restart();
      }

      disconnectedCallback() {
        this.clearTimers();
        if (this.motionQuery && typeof this.motionQuery.removeEventListener === 'function') {
          this.motionQuery.removeEventListener('change', this.handleMotionChange);
        }
      }

      randomBetween(min, max) {
        return Math.floor(Math.random() * (max - min + 1)) + min;
      }

      randomToken(index) {
        const maximums = [99, 23, 59, 59];
        const value = String(this.randomBetween(0, maximums[index] || 59)).padStart(2, '0');

        if (Math.random() < 0.35) {
          const hiddenDigit = this.randomBetween(0, 1);
          return value.split('').map((character, characterIndex) => (
            characterIndex === hiddenDigit ? '?' : character
          )).join('');
        }

        return value;
      }

      renderStatic() {
        this.groups.forEach((group) => {
          group.textContent = '??';
          group.classList.remove('is-changing');
        });
      }

      clearTimers() {
        window.clearInterval(this.scrambleTimer);
      }

      runScramble() {
        this.groups.forEach((group, index) => {
          group.textContent = this.randomToken(index);
        });
      }

      restart() {
        this.clearTimers();
        this.renderStatic();
        if (!this.motionQuery.matches) {
          this.runScramble();
          this.scrambleTimer = window.setInterval(() => this.runScramble(), 50);
        }
      }
    }

    customElements.define('let-em-copy-teaser', LetEmCopyTeaser);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
